import { v2Api } from './v2Client';

export const seasonsService = {
  async getAll() {
    try {
      const { data } = await v2Api.get('/Season/current_all');
      const list = Array.isArray(data) ? data : data ? [data] : [];
      const seasons = list
        .map((s) => ({
          id: s?.season_id ?? s?.seasonId ?? null,
          status: 'running',
        }))
        .filter((s) => s.id != null && String(s.id).trim() !== '')
        .map((s) => ({ ...s, id: String(s.id) }));
      return { data: seasons };
    } catch {
      return { data: [] };
    }
  },
};

export async function fetchSeasonList() {
  const { data } = await v2Api.get('/Season/list');
  return Array.isArray(data) ? data : [];
}

export async function fetchAdminStats(seasonId) {
  const { data } = await v2Api.get('/Season/admin_stats', {
    params: seasonId ? { season_id: String(seasonId) } : {},
  });
  return data;
}

export async function fetchAdminNextBoxPlayers(seasonId, bucket) {
  const { data } = await v2Api.get('/Season/admin_next_box_players', {
    params: {
      bucket: String(bucket || ''),
      ...(seasonId ? { season_id: String(seasonId) } : {}),
    },
  });
  return data;
}

export async function fetchScheduledCalendarBounds(seasonId) {
  const { data } = await v2Api.get('/Season/admin_scheduled_calendar_bounds', {
    params: seasonId ? { season_id: String(seasonId) } : {},
  });
  return data;
}

/** File d'attente admin ; `competitionId` optionnel = liste de cette compétition (absent = toute la liste). */
export async function fetchAdminWaitingList(competitionId) {
  const { data } = await v2Api.get('/Season/admin_waiting_list', {
    params: competitionId ? { competition_id: String(competitionId) } : {},
  });
  return data;
}

/** File d'attente telle que les joueurs la voient dans l'app (`/WaitingList/pending` : triée par date de demande).
 * `competitionId` optionnel = liste de cette compétition. */
export async function fetchPublicWaitingList(competitionId) {
  const { data } = await v2Api.get('/WaitingList/pending', {
    params: competitionId ? { competition_id: String(competitionId) } : {},
  });
  return data;
}

export async function adminWaitingListUpdate(payload) {
  const { data } = await v2Api.post('/Season/admin_waiting_list_update', payload || {});
  return data;
}

export async function adminWaitingListDelete(payload) {
  const { data } = await v2Api.post('/Season/admin_waiting_list_delete', payload || {});
  return data;
}

export async function adminWaitingListReorder(payload) {
  const { data } = await v2Api.post('/Season/admin_waiting_list_reorder', payload || {});
  return data;
}

export async function fetchDayHourMatchCounts(seasonId, dateYmd) {
  const { data } = await v2Api.get('/Season/admin_day_hour_match_counts', {
    params: {
      date: dateYmd,
      ...(seasonId ? { season_id: String(seasonId) } : {}),
    },
  });
  return data;
}

export async function fetchActiveSeriesTimeline(seasonId) {
  try {
    const { data } = await v2Api.get('/Season/active_series_timeline', {
      params: seasonId ? { season_id: String(seasonId) } : {},
    });
    return data;
  } catch (e) {
    if (e?.response?.status === 404) return null;
    throw e;
  }
}

export async function fetchDaySlotMatches(seasonId, slotAtRaw) {
  const slot_at =
    slotAtRaw instanceof Date ? slotAtRaw.toISOString() : slotAtRaw != null ? String(slotAtRaw) : '';
  const { data } = await v2Api.get('/Season/admin_day_slot_matches', {
    params: {
      slot_at,
      ...(seasonId ? { season_id: String(seasonId) } : {}),
    },
  });
  return data;
}
